import React from "react";
import MaterialTable from "material-table";
import axios from "axios";
import Hashids from "hashids";
import CryptoJS from "crypto-js";
import Cookies from "js-cookie";
import { differenceInCalendarDays, format, isValid, parseISO, subDays } from "date-fns";
import {
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import GetAppIcon from "@material-ui/icons/GetApp";
import ImageSearchIcon from "@material-ui/icons/ImageSearch";
import { Lightbox } from "react-modal-image";
import ConfirmDialog from "../alertas/Confirm";
import PrintDialog from "../alertas/Print";
import { getPermissions } from "../../libs/permissions";
import api from "../../service/api";

const BPF_SERVER_URL = process.env.REACT_APP_BPF_SERVER_URL;
const BPF_SHARE_URL = process.env.REACT_APP_BPF_SHARE_URL;
const SECRET_KEY = process.env.REACT_APP_SECRET_KEY;
const MAX_DAYS_RANGE = 40;

export default class TableOs extends React.PureComponent {
  constructor(props) {
    super(props);

    const url = window.location.hostname;
    const urlSplit = url.split(".");
    const today = format(new Date(), "yyyy-MM-dd");
    const initialFromDate = props.initialFromDate || today;
    const initialToDate = props.initialToDate || today;

    this.unmounted = false;
    this.searchCancelSource = null;
    this.requestCounter = 0;
    this.tableRef = React.createRef();
    this.dataCache = [];

    this.columns = [
      { title: "Codigo", field: "id" },
      { title: "Versao", field: "form_version" },
      { title: "Data", field: "date" },
      { title: "Identificador", field: "identifier" },
      { title: "Responsavel", field: "user" },
      { title: "Verificador", field: "checker" },
      { title: "Monitor", field: "supervisor" },
      { title: "Compartilhado", field: "user_share" },
      { title: "Data Compartilhamento", field: "date_sharing" },
      { title: "Data Preenchimento", field: "date_complete" },
      { title: "Ult. Acao", field: "last_action_name" },
      { title: "Id Sharing", field: "sharing_id", hidden: true },
      {
        title: "Checkin",
        field: "checkin",
        hidden: urlSplit[0] !== "heineken",
        render: (rowData) => {
          if (!rowData.checkin) {
            return null;
          }
          const utcDate = new Date(rowData.checkin.replace(" ", "T") + "Z");
          return utcDate.toLocaleString();
        },
      },
    ];

    this.state = {
      loading: false,
      form_id: props.form_id,
      fromDate: props.fromDate,
      toDate: props.toDate,
      data_filter: props.data_filter || "",
      open: false,
      filename_open: "",
      row: null,
      dataFormId: null,
      openPrintDialog: false,
      permissions: null,
      idDelete: null,
      indexFile: null,
      openDialogConfirmDelete: false,
      title: "",
      body: "",
    };
  }

  componentDidMount() {
    this.getDataForms();
    const permissions = getPermissions();
    if (permissions) {
      this.setState({ permissions: JSON.parse(permissions) });
    }
  }

  componentWillUnmount() {
    this.unmounted = true;
    if (this.searchCancelSource) {
      this.searchCancelSource.cancel("Componente desmontado");
    }
  }

  normalizeDateRange = (fromDate, toDate) => {
    const today = format(new Date(), "yyyy-MM-dd");
    let safeToDate = toDate;
    let safeFromDate = fromDate;

    const parsedToDate = parseISO(safeToDate);
    if (!safeToDate || !isValid(parsedToDate)) {
      safeToDate = today;
    }

    const parsedFromDate = parseISO(safeFromDate);
    if (!safeFromDate || !isValid(parsedFromDate)) {
      safeFromDate = safeToDate;
    }

    if (safeFromDate > safeToDate) {
      const temp = safeFromDate;
      safeFromDate = safeToDate;
      safeToDate = temp;
    }

    const rangeInDays = differenceInCalendarDays(
      parseISO(safeToDate),
      parseISO(safeFromDate)
    );

    if (rangeInDays > MAX_DAYS_RANGE) {
      safeFromDate = format(subDays(parseISO(safeToDate), MAX_DAYS_RANGE), "yyyy-MM-dd");
    }

    return { fromDate: safeFromDate, toDate: safeToDate };
  };

  reloadTableQuery = () => {
    if (this.tableRef.current) {
      this.tableRef.current.onQueryChange();
    }
  };

  replaceDataCache = (nextData) => {
    this.dataCache = Array.isArray(nextData) ? nextData : [];
    if (this.unmounted) {
      return;
    }
    this.setState({ loading: false }, this.reloadTableQuery);
  };

  updateDataCache = (updater) => {
    const current = Array.isArray(this.dataCache) ? this.dataCache : [];
    this.dataCache = updater(current);
    this.reloadTableQuery();
  };

  searchForms = (data_filter, fromDate, toDate) => {
    // const normalizedRange = this.normalizeDateRange(fromDate, toDate);
    this.setState(
      {
        data_filter,
        fromDate: fromDate,
        toDate: toDate,
      },
      this.getDataForms
    );
  };

  getUserNameFromCookie = () => {
    const nameCookie = Cookies.get("name_bpf");
    if (!nameCookie) {
      return "";
    }
    return CryptoJS.AES.decrypt(nameCookie, SECRET_KEY).toString(CryptoJS.enc.Utf8);
  };

  setMonitor = (data_form_id) => {
    const name = this.getUserNameFromCookie();
    this.updateDataCache((rows) =>
      rows.map((item) =>
        String(item.id) === String(data_form_id) ? { ...item, supervisor: name } : item
      )
    );
  };

  setVerificador = (data_form_id) => {
    const name = this.getUserNameFromCookie();
    this.updateDataCache((rows) =>
      rows.map((item) =>
        String(item.id) === String(data_form_id) ? { ...item, checker: name } : item
      )
    );
  };

  getDataForms = () => {
    // const normalizedRange = this.normalizeDateRange(this.state.fromDate, this.state.toDate);
    // if (
    //   normalizedRange.fromDate !== this.state.fromDate ||
    //   normalizedRange.toDate !== this.state.toDate
    // ) {
    //   this.setState(
    //     {
    //       fromDate: normalizedRange.fromDate,
    //       toDate: normalizedRange.toDate,
    //     },
    //     this.getDataForms
    //   );
    //   return;
    // }

    if (this.searchCancelSource) {
      this.searchCancelSource.cancel("Nova consulta iniciada");
    }

    this.searchCancelSource = axios.CancelToken.source();
    const requestId = ++this.requestCounter;

    this.setState({ loading: true });
    api
      .get("/data-form/search", {
        params: {
          form_id: this.state.form_id,
          data: this.state.data_filter == "" ? null : this.state.data_filter,
          fromDate: this.state.fromDate,
          toDate: this.state.toDate,
          timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        },
        cancelToken: this.searchCancelSource.token,
      })
      .then((response) => {
        if (this.unmounted || requestId !== this.requestCounter) {
          return;
        }
        if (!response) {
          this.setState({ loading: false });
          return;
        }
        this.replaceDataCache(response.data);
      })
      .catch((error) => {
        if (axios.isCancel(error)) {
          return;
        }
        if (this.unmounted || requestId !== this.requestCounter) {
          return;
        }
        this.setState({ loading: false });
      });
  };

  addFiles = (file) => {
    const rowId = this.state.row?.id;
    if (rowId === null || rowId === undefined) {
      return;
    }

    this.updateDataCache((rows) =>
      rows.map((item) => {
        if (String(item.id) !== String(rowId)) {
          return item;
        }
        const files = Array.isArray(item.files) ? item.files : [];
        return { ...item, files: [...files, file] };
      })
    );
    this.setState({ row: null });
  };

  removeFiles = (indexFile) => {
    const rowId = this.state.row?.id;
    if (rowId === null || rowId === undefined) {
      return;
    }

    this.updateDataCache((rows) =>
      rows.map((item) => {
        if (String(item.id) !== String(rowId)) {
          return item;
        }
        const files = Array.isArray(item.files) ? item.files : [];
        return {
          ...item,
          files: files.map((file, idx) =>
            idx === indexFile ? { ...file, status: "0" } : file
          ),
        };
      })
    );

    this.setState({ row: null, indexFile: null });
  };

  modalView = (filename) => {
    this.setState({ open: true, filename_open: filename });
  };

  removeRows = () => {
    this.setState({ row: null });
  };

  closeLightbox = () => {
    this.setState({ open: false });
  };

  downloadImagem = (nomeArquivo) => {
    window.open(`${BPF_SERVER_URL}/downloadFile?filename=${nomeArquivo}`);
  };

  openShare = (rowData) => {
    const hashids = new Hashids();
    const url = `${BPF_SHARE_URL}/?form=${hashids.encode(this.state.form_id)}&sharing=${hashids.encode(rowData.sharing_id)}&data_form=${hashids.encode(rowData.id)}`;
    window.open(url);
  };

  deleteImage = (id, indexFile) => {
    this.setState({
      idDelete: id,
      indexFile,
      openDialogConfirmDelete: true,
      title: "Atencao",
      body: "Deseja deletar o arquivo?",
    });
  };

  handleDelete = () => {
    api
      .delete(`/filesDataForm/${this.state.idDelete}`)
      .then(() => {
        this.setState({ idDelete: null, openDialogConfirmDelete: false });
        this.removeFiles(this.state.indexFile);
      })
      .catch(() => {
        this.setState({ idDelete: null, openDialogConfirmDelete: false });
      });
  };

  handleClose = () => {
    this.setState({ idDelete: null, openDialogConfirmDelete: false });
  };

  handlePrintV = () => {
    if (this.state.dataFormId !== null && this.state.dataFormId !== undefined) {
      window.open(
        `${BPF_SERVER_URL}/generate-pdf/${this.state.dataFormId}?timezone=${Intl.DateTimeFormat().resolvedOptions().timeZone}`
      );
    }
    this.setState({ dataFormId: null, openPrintDialog: false });
  };

  handlePrintH = () => {
    if (this.state.dataFormId !== null && this.state.dataFormId !== undefined) {
      window.open(
        `${BPF_SERVER_URL}/generate-pdf/${this.state.dataFormId}?pgOrientation=landscape&timezone=${Intl.DateTimeFormat().resolvedOptions().timeZone}`
      );
    }
    this.setState({ dataFormId: null, openPrintDialog: false });
  };

  getActions = () => {
    const actions = [
      {
        icon: "add",
        tooltip: "Add",
        isFreeAction: true,
        onClick: () => this.props.add(),
      },
      {
        icon: "share",
        tooltip: "Compartilhar",
        isFreeAction: true,
        onClick: () => this.props.share(),
      },
      {
        icon: "edit",
        tooltip: "Editar Dados",
        onClick: (event, rowData) => this.props.edit(rowData.id, rowData.is_editable),
      },
      (rowData) => ({
        icon: "description",
        tooltip: "PDF",
        onClick: (event, rowDataCurrent) => {
          const url = window.location.hostname;
          const urlSplit = url.split(".");
          if (urlSplit[0] === "sbr") {
            this.setState({
              dataFormId: rowDataCurrent.id,
              openPrintDialog: true,
            });
          } else {
            window.open(`${BPF_SERVER_URL}/generate-pdf/${rowDataCurrent.id}`);
          }
        },
        disabled:
          (rowData.date_complete === null || rowData.date_complete === undefined) &&
          rowData.date_sharing !== null &&
          rowData.date_sharing !== undefined,
      }),
      {
        icon: "attach_file",
        tooltip: "Anexos",
        onClick: (event, rowData) => {
          this.setState({ row: rowData });
          this.props.attach(rowData.id);
        },
      },
      (rowData) => ({
        icon: "share",
        tooltip: "Link Compartilhado",
        onClick: () => this.openShare(rowData),
        disabled: rowData.date_sharing === null || rowData.date_sharing === undefined,
      }),
      (rowData) => ({
        icon: "backup",
        tooltip: "Logs",
        onClick: () => this.props.logs(rowData.id),
      }),
    ];

    if (this.state.permissions?.name === "ADMINISTRADOR") {
      actions.push({
        icon: "feedback",
        tooltip: "Solicitar edicao",
        onClick: (event, rowData) => this.props.audit(rowData.id, rowData.is_editable),
      });
    }

    return actions;
  };

  resolveTableData = (query) => {
    const sourceRows = Array.isArray(this.dataCache) ? this.dataCache : [];
    let rows = sourceRows;

    if (query.orderBy && query.orderDirection) {
      const field = query.orderBy.field;
      const order = query.orderDirection === "asc" ? 1 : -1;
      rows = [...sourceRows].sort((a, b) => {
        const aValue = a?.[field];
        const bValue = b?.[field];

        if (aValue === bValue) {
          return 0;
        }
        if (aValue === null || aValue === undefined) {
          return -1 * order;
        }
        if (bValue === null || bValue === undefined) {
          return 1 * order;
        }
        return aValue > bValue ? order : -1 * order;
      });
    }

    const pageSize = query.pageSize || 25;
    const page = query.page || 0;
    const start = page * pageSize;
    const end = start + pageSize;

    return Promise.resolve({
      data: rows.slice(start, end),
      page,
      totalCount: rows.length,
    });
  };

  renderDetailPanel = (rowData) => {
    const files = Array.isArray(rowData.files) ? rowData.files : [];
    return (
      <Paper
        margin={1}
        style={{
          boxShadow: "1px 3px 1px #ddd",
          padding: "10px",
          margin: "10px",
        }}
      >
        <Typography
          variant="h6"
          gutterBottom
          component="div"
          style={{
            fontSize: "1rem",
            color: "#fff",
            backgroundColor: "#256F44",
            textAlign: "center",
            borderRadius: "5px",
            padding: "10px",
          }}
        >
          INFORMACOES DOS ARQUIVOS
        </Typography>
        <Table size="small" aria-label="purchases">
          <TableHead>
            <TableRow>
              <TableCell align="center">Nome do Arquivo</TableCell>
              <TableCell align="center">Data Criacao</TableCell>
              <TableCell align="center">Status</TableCell>
              <TableCell align="center">Acoes</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {files.map((file, indexFile) => (
              <TableRow key={file.id || `${file.filename}-${indexFile}`}>
                <TableCell align="center" component="th" scope="row">
                  {file.filename}
                </TableCell>
                <TableCell align="center">{file.created_at}</TableCell>
                <TableCell align="center">{file.status === "1" ? "Ativo" : "Inativo"}</TableCell>
                <TableCell align="center">
                  <IconButton
                    disabled={file.status === "0"}
                    aria-label="view"
                    onClick={() => this.modalView(file.filename)}
                  >
                    <ImageSearchIcon fontSize="small" />
                  </IconButton>
                  <IconButton
                    disabled={file.status === "0"}
                    aria-label="download"
                    onClick={() => this.downloadImagem(file.filename)}
                  >
                    <GetAppIcon fontSize="small" />
                  </IconButton>
                  <IconButton
                    disabled={file.status === "0"}
                    aria-label="delete"
                    onClick={() => {
                      this.setState({ row: rowData });
                      this.deleteImage(file.id, indexFile);
                    }}
                  >
                    <DeleteIcon fontSize="small" />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Paper>
    );
  };

  render() {
    return (
      <div>
        {this.state.open && (
          <Lightbox
            large={`${BPF_SERVER_URL}/showFile?filename=${this.state.filename_open}`}
            alt={this.state.filename_open}
            onClose={this.closeLightbox}
          />
        )}
        {this.state.openDialogConfirmDelete && (
          <ConfirmDialog
            title={this.state.title}
            body={this.state.body}
            handleCloseConfirmT={this.handleDelete}
            handleCloseConfirmF={this.handleClose}
          />
        )}
        {this.state.openPrintDialog && (
          <PrintDialog
            handleCloseConfirmH={this.handlePrintH}
            handleCloseConfirmV={this.handlePrintV}
          />
        )}

        <MaterialTable
          tableRef={this.tableRef}
          isLoading={this.state.loading}
          columns={this.columns}
          data={this.resolveTableData}
          title={this.props.name}
          options={{
            search: false,
            pageSize: 5,
            pageSizeOptions: [5, 15, 25, 50, 100],
            emptyRowsWhenPaging: false,
            debounceInterval: 500,
          }}
          actions={this.getActions()}
          detailPanel={[
            {
              render: this.renderDetailPanel,
            },
          ]}
        />
      </div>
    );
  }
}
